package com.anjuros.website.templates.template5.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.WaveDivider
import com.anjuros.website.templates.template5.components.Template5PrimaryButton
import com.anjuros.website.templates.template5.components.Template5SecondaryButton
import com.anjuros.website.templates.template5.modules.Template5HeaderItem
import com.anjuros.website.templates.template5.modules.Template5HeroFeature
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.modules.getColorOpacity
import com.anjuros.website.templates.template5.modules.getColorOpacity2Hex
import com.anjuros.website.templates.template5.modules.getColorOpacityHex
import com.anjuros.website.templates.template5.styles.Template5HeroFeatureCardStyle
import com.anjuros.website.templates.template5.styles.Template5HeroH1FontStyle
import com.anjuros.website.templates.template5.styles.Template5HeroImageStyle
import com.anjuros.website.templates.template5.util.ResKey
import com.anjuros.website.templates.template5.util.Template5Constants.FONT_FAMILY_CRAFT
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexBasis
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template5MainSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    showCircles:Boolean = true){
    Box(
        modifier = modifier
            .id("home")
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {

        Template5Hero(showCircles = showCircles)
    }
}
@Composable
fun Template5Hero(showCircles: Boolean) {

    var imageVisible by remember {
        mutableStateOf(false)
    }

    LaunchedEffect(Unit) {
        delay(150)
        imageVisible = true
    }
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Template5Theme.Background.getColorOpacity())
            .overflow(Overflow.Hidden)
    ) {

        //====================================================
        // BACKGROUND CIRCLES
        //====================================================

        if(showCircles) {
            Box(
                modifier = Modifier
                    .position(Position.Absolute)
                    .right((0).px)
                    .top((-80).px)
                    .size(500.px)
                    .backgroundColor(Template5Theme.SecondaryLight.getColor())
                    .borderRadius(50.percent)
                    .opacity(.55f)
            )

            Box(
                modifier = Modifier
                    .position(Position.Absolute)
                    .right(120.px)
                    .top(220.px)
                    .size(260.px)
                    .backgroundColor(Template5Theme.Secondary.getColor())
                    .borderRadius(50.percent)
                    .opacity(.12f)
            )
        }

        //====================================================
        // CONTENT
        //====================================================

        Column(
            modifier = Modifier.fillMaxWidth()
            ,
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .displayIfAtLeast(Breakpoint.LG)
                    .padding(leftRight = 50.px),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {

                //------------------------------------------------
                // LEFT
                //------------------------------------------------

                Template5HeroTexts(
                    modifier = Modifier.flexBasis(48.percent),
                    mobile = false,
                    imageVisible = imageVisible)

                Template5HeroImage(
                    imageVisible = imageVisible
                )
                Template5Features()

            }
            Column(
                modifier = Modifier
                    .fillMaxWidth(90.percent)
                    .displayUntil(Breakpoint.LG)
                    .margin(top = 15.px)
                    ,
                verticalArrangement = Arrangement.spacedBy(60.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                //------------------------------------------------
                // LEFT
                //------------------------------------------------

                Template5HeroTexts(
                    modifier = Modifier.fillMaxWidth(),
                    mobile = true,
                    imageVisible = imageVisible)

                Box(modifier = Modifier.fillMaxWidth()) {
                    Template5HeroImage(
                        imageVisible = imageVisible
                    )
                    Template5Features(
                        modifier = Modifier.align(Alignment.Center)
                    )
                }

            }
            //====================================================
            // BOTTOM WAVE
            //====================================================

            WaveDivider(
                backgroundColor = Template5Theme.Background.getColorOpacityHex(),
                waveColor ="#ffffff"
            )


        }
    }
}

@Composable
fun Template5Features(
    modifier: Modifier = Modifier
){
    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(20.px),
        horizontalAlignment = Alignment.Start
    ) {
        Template5HeroFeature.entries.forEach { card ->
            Template5HeroFeatureCard(
                card = card
            )

        }
    }
}

@Composable
fun Template5HeroImage(
    imageVisible:Boolean
){
    Box(
        modifier = Template5HeroImageStyle.toModifier()
    ) {

        AnjurosImage(
            modifier =  Modifier

                .opacity(
                    if (imageVisible) 1f else 0f
                )
                .scale(
                    if (imageVisible) 1 else 0.94
                )
                .translateY(
                    if (imageVisible) 0.px else 30.px
                )
                .transition(
                    Transition.of(
                        "opacity",
                        700.ms
                    ),
                    Transition.of(
                        "scale",
                        700.ms
                    ),
                    Transition.of(
                        "translate",
                        700.ms
                    )
                )
                .fillMaxHeight()
                .zIndex(2.0)
                .fillMaxWidth(),
            src = "template5_hero.webp",
            alt = "Beautiful handmade celebration cake"
        )

        //------------------------------------------------
        // FLOATING FEATURE 1
        //------------------------------------------------

    }
}

@Composable
fun Template5HeroTexts(
    modifier: Modifier,
    mobile:Boolean,
    imageVisible:Boolean
){
    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.Center
    ) {


        H1(
            attrs = Template5HeroH1FontStyle.toModifier()
                .fontFamily(FONT_FAMILY_CRAFT)
                .zIndex(3.0)
                .lineHeight(1.1)
                .whiteSpace(WhiteSpace.PreLine)
                .fontWeight(FontWeight.Bold)
                .color(Template5Theme.Primary.getColor())
                .margin(top = 20.px, bottom = 5.px)
                .opacity(
                    if (imageVisible) 1f else 0f
                )
                .transition(
                    Transition.of(
                        "opacity",
                        900.ms,
                        delay = 300.ms
                    )
                )
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE5_HERO_TITLE))
        }

        P(
            attrs = Modifier
                .fontSize(18.px)
                .zIndex(3.0)
                .lineHeight(1.8)
                .maxWidth(560.px)
                .color(rgb(105, 105, 105))
                .margin(bottom = 36.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE5_HERO_DESCRIPTION))
        }

        Row(
            modifier = Modifier
                .flexDirection(if(mobile) FlexDirection.Column else FlexDirection.Row),
            horizontalArrangement = Arrangement.spacedBy(16.px)
        ) {

            Template5PrimaryButton(
                text = LocalText(ResKey.TEMPLATE5_HERO_BUTTON_ORDER),
                path = Template5HeaderItem.CONTACT.path
            )

            Template5SecondaryButton(
                text = LocalText(ResKey.TEMPLATE5_HERO_BUTTON_PRODUCTS),
                path = Template5HeaderItem.PRODUCTS.path
            )

        }

    }
}

@Composable
fun Template5HeroFeatureCard(
    card: Template5HeroFeature
) {

    Row(
        modifier = Template5HeroFeatureCardStyle.toModifier()
            .boxShadow(
                offsetY = 8.px,
                blurRadius = 30.px,
                color = rgba(0, 0, 0, 0.6)
            )
            .border(
                width = 1.px,
                color = Template5Theme.Primary.getColor(),
                style = LineStyle.Solid
            )
            .width(220.px)
            .zIndex(3.0)
            .backgroundColor(Colors.White)
            .borderRadius(22.px)
            .padding(18.px)
            ,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(16.px)
    ) {

        //----------------------------------------------------
        // ICON
        //----------------------------------------------------

        Box(
            modifier = Modifier
                .size(50.px)
                .backgroundColor(Template5Theme.SecondaryLight.getColor())
                .borderRadius(50.percent)
                .flexShrink(0)
                .justifyContent(JustifyContent.Center)
                .alignItems(AlignItems.Center)
        ) {

            AnjurosIcon(
                modifier = Modifier.size(30.px).align(Alignment.Center),
                src = card.icon,
                alt = LocalText(card.title)
            )

        }

        //----------------------------------------------------
        // TEXT
        //----------------------------------------------------

        Column {

            P(
                attrs = Modifier
                    .fontSize(17.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Template5Theme.Primary.getColor())
                    .margin(bottom = 4.px)
                    .toAttrs()
            ) {
                Text(LocalText(card.title))
            }

            P(
                attrs = Modifier
                    .fontSize(14.px)
                    .lineHeight(1.5)
                    .color(rgb(120, 120, 120))
                    .margin(0.px)
                    .toAttrs()
            ) {
                Text(LocalText(card.text))
            }

        }

    }

}

@Composable
fun Template5Badge(
    text: String
) {

    Box(
        modifier = Modifier
            .backgroundColor(Template5Theme.SecondaryLight.getColorOpacity())
            .borderRadius(50.percent)
            .padding(
                left = 18.px,
                right = 18.px,
                top = 10.px,
                bottom = 10.px
            )
    ) {


        P(
            attrs = Modifier
                .fontSize(13.px)
                .fontWeight(FontWeight.SemiBold)
                .letterSpacing(.12.em)
                .textTransform(TextTransform.Uppercase)
                .color(Template5Theme.Primary.getColor())
                .margin(0.px)
                .toAttrs()
        ) {
            Text(text)
        }

    }

}
